import { render, staticRenderFns } from "./AdminRow.vue?vue&type=template&id=07b6059d&"
import script from "./AdminRow.vue?vue&type=script&lang=ts&"
export * from "./AdminRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports